function togglePageOverflow<T extends HTMLElement>(elementName: string, condition: boolean) {
    const element = document.getElementsByTagName(elementName)[0] as T;

    if (element) element.style.overflow = condition ? 'auto' : 'hidden';
}

export default togglePageOverflow;
